module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "id": "bulk-payment-modal",
      "title": "Bulk Payment - Update Selected Payments",
      "size": "xl",
      "dialog-class": "modal-xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "text-center p-4"
  }, [_c('b-spinner', {
    attrs: {
      "label": "Loading..."
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "mb-3 text-right"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.showApplyToAll = !_vm.showApplyToAll
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.showApplyToAll ? 'Hide Apply Same Values' : 'Apply Same Values to All') + "\n      ")])], 1), _vm._v(" "), (_vm.showApplyToAll) ? _c('b-card', {
    staticClass: "mb-3",
    staticStyle: {
      "background-color": "#f8f9fa"
    }
  }, [_c('h6', {
    staticClass: "mb-3"
  }, [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Apply Same Values to All")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Pay Mode",
      "label-for": "apply-pay-mode"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "apply-pay-mode",
      "options": _vm.payModeOptions
    },
    model: {
      value: (_vm.applyToAll.inv_pay_mode),
      callback: function($$v) {
        _vm.$set(_vm.applyToAll, "inv_pay_mode", $$v)
      },
      expression: "applyToAll.inv_pay_mode"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Pay Mode")])])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Reference No",
      "label-for": "apply-ref-no"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "apply-ref-no",
      "placeholder": "Reference No"
    },
    model: {
      value: (_vm.applyToAll.inv_pay_ref_no),
      callback: function($$v) {
        _vm.$set(_vm.applyToAll, "inv_pay_ref_no", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "applyToAll.inv_pay_ref_no"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Amount",
      "label-for": "apply-amt"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "apply-amt",
      "type": "number",
      "step": "0.01",
      "min": "0",
      "placeholder": "Amount"
    },
    model: {
      value: (_vm.applyToAll.inv_pay_amt),
      callback: function($$v) {
        _vm.$set(_vm.applyToAll, "inv_pay_amt", _vm._n($$v))
      },
      expression: "applyToAll.inv_pay_amt"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Payment Date",
      "label-for": "apply-date"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "apply-date",
      "type": "date"
    },
    model: {
      value: (_vm.applyToAll.inv_pay_date),
      callback: function($$v) {
        _vm.$set(_vm.applyToAll, "inv_pay_date", $$v)
      },
      expression: "applyToAll.inv_pay_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.applyAllFieldsToAll
    }
  }, [_vm._v("\n            Apply All Fields to All Rows\n          ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "max-height": "500px",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_c('thead', {
    staticClass: "thead-light",
    staticStyle: {
      "position": "sticky",
      "top": "0",
      "z-index": "10",
      "background": "#f8f9fa"
    }
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("SN")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "120px"
    }
  }, [_vm._v("Transaction No")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "100px"
    }
  }, [_vm._v("Job No")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "100px"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "120px"
    }
  }, [_vm._v("Inv Amount")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "120px"
    }
  }, [_vm._v("Inv Date")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "150px"
    }
  }, [_vm._v("Particular")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "100px"
    }
  }, [_vm._v("Currency")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "120px"
    }
  }, [_vm._v("Sell Amount")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "120px"
    }
  }, [_vm._v("Bill To Customer")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "150px"
    }
  }, [_vm._v("Remark")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "120px"
    }
  }, [_vm._v("Document")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "120px"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-checkbox', {
    staticClass: "mr-2",
    on: {
      "change": function (checked) {
        if (checked) { _vm.applyPayModeToAll(); }
        else { _vm.clearPayModeFromAll(); }
      }
    },
    model: {
      value: (_vm.applyFieldCheckboxes.inv_pay_mode),
      callback: function($$v) {
        _vm.$set(_vm.applyFieldCheckboxes, "inv_pay_mode", $$v)
      },
      expression: "applyFieldCheckboxes.inv_pay_mode"
    }
  }), _vm._v("\n                Pay Mode\n              ")], 1)]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "150px"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-checkbox', {
    staticClass: "mr-2",
    on: {
      "change": function (checked) {
        if (checked) { _vm.applyRefNoToAll(); }
        else { _vm.clearRefNoFromAll(); }
      }
    },
    model: {
      value: (_vm.applyFieldCheckboxes.inv_pay_ref_no),
      callback: function($$v) {
        _vm.$set(_vm.applyFieldCheckboxes, "inv_pay_ref_no", $$v)
      },
      expression: "applyFieldCheckboxes.inv_pay_ref_no"
    }
  }), _vm._v("\n                Reference No\n              ")], 1)]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "120px"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-checkbox', {
    staticClass: "mr-2",
    on: {
      "change": function (checked) {
        if (checked) { _vm.applyAmountToAll(); }
        else { _vm.clearAmountFromAll(); }
      }
    },
    model: {
      value: (_vm.applyFieldCheckboxes.inv_pay_amt),
      callback: function($$v) {
        _vm.$set(_vm.applyFieldCheckboxes, "inv_pay_amt", $$v)
      },
      expression: "applyFieldCheckboxes.inv_pay_amt"
    }
  }), _vm._v("\n                Amount\n              ")], 1)]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "120px"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-checkbox', {
    staticClass: "mr-2",
    on: {
      "change": function (checked) {
        if (checked) { _vm.applyDateToAll(); }
        else { _vm.clearDateFromAll(); }
      }
    },
    model: {
      value: (_vm.applyFieldCheckboxes.inv_pay_date),
      callback: function($$v) {
        _vm.$set(_vm.applyFieldCheckboxes, "inv_pay_date", $$v)
      },
      expression: "applyFieldCheckboxes.inv_pay_date"
    }
  }), _vm._v("\n                Payment Date\n              ")], 1)]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "100px"
    }
  }, [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.paymentItems), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(item.transactionNo || item.TransactionNo || item.ape_transaction_no || '-'))]), _vm._v(" "), _c('br'), _vm._v(" "), (!item.isParent) ? _c('small', {
      staticClass: "text-muted"
    }, [_vm._v("Child Item")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.JobNo || item.jobNo || '-'))]), _vm._v(" "), _c('td', [_c('b-badge', {
      attrs: {
        "variant": item.PaymentType == 1 ? 'info' : (item.PaymentType == 2 ? 'secondary' : 'light')
      }
    }, [_vm._v("\n                " + _vm._s(item.PaymentType == 1 ? 'Exp' : (item.PaymentType == 2 ? 'Additional Task' : '-')) + "\n              ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.inv_amt || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.inv_date ? _vm.formatDate(item.inv_date) : '-'))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(item.ledgermaster_relation && item.ledgermaster_relation.ledger ?
      item.ledgermaster_relation.ledger :
      (item.ledger || item.Particular || '-')) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(item.master_currency_relation && item.master_currency_relation.currencyCode ?
      item.master_currency_relation.currencyCode :
      (item.currency || item.Currency || '-')) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.selling_amt || item.sellAmount || '-'))]), _vm._v(" "), _c('td', [_c('b-badge', {
      attrs: {
        "variant": item.sc_category == 'Yes' ? 'success' : 'secondary'
      }
    }, [_vm._v("\n                " + _vm._s(item.sc_category || '-') + "\n              ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.sc_remark || item.remark || '-'))]), _vm._v(" "), _c('td', [(item.inv_doc_url) ? _c('b-button', {
      staticClass: "p-1",
      staticStyle: {
        "font-size": "0.7rem",
        "line-height": "1"
      },
      attrs: {
        "size": "sm",
        "variant": "warning",
        "href": _vm.getDocumentUrl(item.inv_doc_url),
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_vm._v("\n                View Doc\n              ")]) : _c('span', [_vm._v("-")])], 1), _vm._v(" "), _c('td', [_c('b-form-select', {
      attrs: {
        "options": _vm.payModeOptions,
        "size": "sm",
        "state": _vm.getFieldState(item, 'inv_pay_mode')
      },
      model: {
        value: (item.inv_pay_mode),
        callback: function($$v) {
          _vm.$set(item, "inv_pay_mode", $$v)
        },
        expression: "item.inv_pay_mode"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Select")])])], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "placeholder": "Reference No",
        "size": "sm",
        "state": _vm.getFieldState(item, 'inv_pay_ref_no')
      },
      model: {
        value: (item.inv_pay_ref_no),
        callback: function($$v) {
          _vm.$set(item, "inv_pay_ref_no", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "item.inv_pay_ref_no"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "type": "number",
        "step": "0.01",
        "min": "0",
        "placeholder": "Amount",
        "size": "sm",
        "state": _vm.getFieldState(item, 'inv_pay_amt')
      },
      model: {
        value: (item.inv_pay_amt),
        callback: function($$v) {
          _vm.$set(item, "inv_pay_amt", _vm._n($$v))
        },
        expression: "item.inv_pay_amt"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "type": "date",
        "size": "sm",
        "state": _vm.getFieldState(item, 'inv_pay_date')
      },
      model: {
        value: (item.inv_pay_date),
        callback: function($$v) {
          _vm.$set(item, "inv_pay_date", $$v)
        },
        expression: "item.inv_pay_date"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-badge', {
      attrs: {
        "variant": item.InvPayStatus == 1 ? 'success' : 'warning'
      }
    }, [_vm._v("\n                " + _vm._s(item.InvPayStatus == 1 ? 'Paid' : 'Pending') + "\n              ")])], 1)])
  }), _vm._v(" "), (!_vm.paymentItems || _vm.paymentItems.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-3",
    attrs: {
      "colspan": "16"
    }
  }, [_vm._v("\n              No payment items selected\n            ")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-alert', {
    attrs: {
      "variant": "info",
      "show": ""
    }
  }, [_c('strong', [_vm._v("Total Selected:")]), _vm._v(" " + _vm._s(_vm.paymentItems.length) + " payment(s)\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end mt-3"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-secondary",
      "disabled": _vm.isSubmitting
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n        Cancel\n      ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.isSubmitting || !_vm.isFormValid
    },
    on: {
      "click": _vm.submitBulkPayment
    }
  }, [(_vm.isSubmitting) ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.isSubmitting ? 'Processing...' : 'Save All Payments') + "\n      ")], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86fadada","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/BulkPaymentModal.vue
// module id = 2792
// module chunks = 0